<template>
    <div class="main-container page__forgetPassword page__forgetPassword--reset">
        <div class="alert alert--information alert__askNFC" v-if="emailSend">
            <div class="alert__header">
                <div class="alert__title">
                    <p>{{translationArray.email_sent_short}}</p>
                </div>
                <hr>
            </div>

            <div class="alert__body">
                <div class="alert__image">
                    <svg width="45" height="42" viewBox="0 0 45 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1C1 1 12.4025 7.69364 18.7059 10.702M1 1V28.2222M1 1H44M44 1C44 1 32.5975 7.69364 26.2941 10.702M44 1V28.2222M18.7059 10.702C20.5329 11.574 21.9316 12.1364 22.5 12.1364C23.0684 12.1364 24.4671 11.574 26.2941 10.702M18.7059 10.702L1 28.2222M1 28.2222H44M26.2941 10.702L44 28.2222" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.5 35H43.5M8 39.8889H37" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </div>
                <div class="alert__description">
                    <p>{{translationArray.email_sent}}</p>
                </div>
            </div>
        </div>
        <header class="headerBlue">
            <a @click="historyBack()" class="btnBack">
                <span class="btnBack__svg">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="arrow_back_24px">
                    <path id="icon/navigation/arrow_back_24px" d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#3CB5A8"/>
                    </g>
                    </svg>
                </span>
            </a>
            <div class="containerTitle">
                <h1>{{translationArray.password}}</h1>
                <p><span class="containerTitle__subtitle">{{translationArray.reinit_password}}</span></p>
            </div>

            <div class="containerPartner" v-bind:class="{ 'smallContainer': isSmallDesktop }">
                <div class=" partnerBox partnerBox__Right">
                    <img src="../../static/img/senzu.png" alt="">
                </div>
            </div>
            
            <div class="containerDescription">
                <p class="information__title__computer">{{translationArray.reinit_password}}</p>
                <p class="containerDescription--forget">{{translationArray.reinit_password_email}}</p>
                <p class="containerDescription--forget">{{translationArray.reinit_password_next}}</p>
            </div>
        </header>
        <section class="body">
            <form class="roleForm" method="POST" @submit="validateForm">
                <p class="form__title" >{{translationArray.with_email}}</p>
                <fieldset class="formRow">
                    <legend>{{translationArray.email}}</legend>
                    <input type="email" v-model="email">
                </fieldset>
                
                <input class="submit submit--margin submit--width" type="submit" value="Envoyer le mail">
            <!-- <div class="submit submit--margin submit--width"><p>Accepter les rôles</p> -->
            </form>
        
        </section>
        <footer>
            <p>{{translationArray.more_on}}<a href="#" class="link_confidentiality">{{translationArray.privacy_rules}}</a></p>
        </footer>
    </div>
</template>

<script>
    import {translate} from '../../static/js/translate';

    export default {
        name: 'ResetPassword',
        mounted() {
            this.translationArray = translate(navigator.language.substr(0, 2));

            let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
            if(clientId <= 8 || typeof(clientId) == 'undefined') {
                this.isSenzuApp = true;
            }

            window.addEventListener("resize", this.handleResize);
            this.handleResize();

            document.title = "Senzu | Mot de passe oublié";
        },
        data () {
            return {
                users: null,
                isSenzuApp: false,
                email: null,
                isDesktop: false,
                isMobile: true,
                emailSend: false,
                translationArray: {},
                csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        methods: {
            handleResize: function() {
                if(window.innerWidth <= 1120) {
                    this.isMobile = true;
                    this.isDesktop = false;
                } else {
                    this.isMobile = false;
                    this.isDesktop = true;
                }
            },
            historyBack: function() {
                this.$router.replace({name: "Authorize", query: 
                    {
                        client_id: this.$route.query.client_id, 
                        redirect_uri: this.$route.query.redirect_uri,
                        response_type: this.$route.query.response_type,
                        scope: this.$route.query.scope,
                        code_challenge: this.$route.query.code_challenge,
                        code_challenge_method: this.$route.query.code_challenge_method,
                        state: this.$route.query.state,
                    }
                });
            },
            validateForm: function(e) {
                e.preventDefault();
                const data = {email: this.email};
                fetch(`${this.$origin}/reset-password`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'CSRF-Token': this.csrfToken
                    },
                    body: JSON.stringify(data)
                }).then(result => result.json())
                .then(data => {
                    this.emailSend = true;
                });
            }
        }
    }
</script>
        



// WEBPACK FOOTER //
// src/components/ResetPassword.vue